export default {"src":"/_next/static/media/TD.078d733c.svg","height":18,"width":18};